import useSession from "hooks/useSession";
import {
  LegalFooter,
  MSummaryAveStepper,
  PExtrasTrip,
  PPassengerStep,
  PResumeStep,
  PSeatingStep,
  UiAveStepper,
} from "libs/raas-ui-react-components/src/components";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {BodyExtrasObj, EDiscoutCardEnum, EPassengerFormVariant, ESeatingTypes, ExtraData, ExtraSelectedObject, IPassengerList, ResponseExtrasCall, TariffsExtras, TripList, ISeatData } from './AveFlow.model';
import {
  deleteDuplicateArray,
  EmptyDiscountState,
  EmptyExtrasState,
  ExtrasPageLiterals,
  generalFamilyCard,
  getFooterLiterals,
  literalExtrasConverter,
  PassengerStepLiteralsPage,
  passengerTypeLiterals,
  pricesConverter,
  resumeLiteralsPage,
  SeatingCardsList,
  SeatingPageliterals,
  specialFamilyCard,
  steps,
  SummaryAveLiterals
} from "./AveFlow.util";
import "./AveFlow.scss";
import { SessionStorageItems, setDataCodePromoSession, setOffSite, setReturnTripSummaryDetail, setTripSummaryDetail } from "services/user/user.session.service";
import {
  IAveDiscountCardSection,
  ITripSelectedDetails,
  SelectedTariff,
  Summary,
  Traveller,
  Trip,
} from "models/TripInterface";
import { formatPrice } from "services/util/trips.service";
import { getDepartureDate, getSeatTrainMap, mappingLiteralDiscounts, setBookingsExtrasCall } from "./AveFlow.service";
import { emptyArray } from "services/util/util.service";
import { useTranslation } from "react-i18next";
import { removeItemStorage } from "services/util/sessionStorage.service";

export const AveFlow = () => {
  const [t/*, i18n*/] = useTranslation("aveFlow");
  const footerLiterals = getFooterLiterals(t);
  const { tripSelectedDetails, userConnected, tripReturnSelectedDetails, setTripSelectedDetails, setReturnTripSelectedDetails } = useSession();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [passengerList, setPassengerList] = useState([] as IPassengerList[]);

  const [departureDiscountCard, setDepartureDiscountCard] = useState({} as any);
  const [returnDiscountCard, setReturnDiscountCard] = useState({} as any);

  const [passengersExtrasCard, setPassengersExtrasCard] = useState({} as any);
  const [departureResponseExtrasList, setDepartureResponseExtrasList] = useState([] as any);
  const [returnResponseExtrasList, setReturnResponseExtrasList] = useState([] as any);
  const [departureExtrasCard, setDepartureExtrasCard] = useState([] as any);
  const [returnExtrasCard, setReturnExtrasCard] = useState([] as any);

  const [departureSeating, setDepartureSeating] = useState({} as any);
  const [returnSeating, setReturnSeating] = useState({} as any);
  const [seatingSelected, setSeatingSelected] = useState({} as any);
  const [extraSelected, setExtraSelected] = useState({} as any);
  //let extraSelected={}as any

  // summary
  const [summaryTopSection, setSummaryTopSection] = useState({} as any);
  const [otherTransportSumPrice, setOtherTransportSumPrice] = useState(0);
  const [priceItemsList, setPriceItemsList] = useState([] as any);
  const [showAproxLiteralSection, setShowAproxLiteralSection] = useState(false);

  //Resume step
  const [resumeDepartureSection, setResumeDepartureSection] = useState([] as any);
  const [resumeReturnSection, setResumeReturnSection] = useState([] as any);

  //seating Map
  const [departureComplementList, setDepartureSeatComplementList] = useState([] as any);
  const [returnComplementList, setReturnSeatComplementList] = useState([] as any);

//Litelares Steps
//const [seatingPageliterals, setSeatingPageliterals] = useState(SeatingPageliterals(t));
const seatingPageliterals= SeatingPageliterals(t);
const resumeLiteralsPageLocal= resumeLiteralsPage(t);


const [seatingDeparture, setSeatingDeparture] = useState([] as any);
const [seatingReturnSection, setSeatingReturnSection] = useState([] as any);
const [passengerStepLiteralsPageData, setPassengerStepLiteralsPage] = useState(
  JSON.stringify(PassengerStepLiteralsPage(t))
);

let lenguage="";

  useEffect(() => {
    if (sessionStorage.getItem('raas-language') != lenguage) {
      lenguage = sessionStorage.getItem('raas-language')as any
      summaryMapSection();
      discountCardMapSection();
      setPassengerStepLiteralsPage(PassengerStepLiteralsPage(t)as any)
      seatingDepartureSectionMap(seatingDeparture);
      if (!emptyArray(departureResponseExtrasList) && currentStep==1) {
        //Resvisar en el futuro evitar llamada al back de nuevo para cambiar de idioma , ida viene traducido de atras buscar forma
        const tariffsExtras: TariffsExtras[][] = departureResponseExtrasList.map((extra: any) => extra.data?.tariffs);
        const payedPassenger = tripSelectedDetails?.aveDeparture?.payedPassengerNumber;
        const seatList = _getSeatList(tariffsExtras, payedPassenger);
        setDepartureSeatComplementList(seatList);
        
      
        if(seatingReturnSection){
          seatingReturnSectionMap(seatingReturnSection)
        }
      }
      if(currentStep==3){
        resumeStepMapSection();
      }
    }
  }, [t]);

  useEffect(() => {
    setOffSite(false)
    setDataCodePromoSession({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false,totalPrice:'0,00 €',totalPriceToPay:'0,00 €' })
    discountCardMapSection();
    seatingDepartureSectionMap([]);
    seatingReturnSectionMap([]);
    summaryMapSection();
    const passengerListMapped = mapPassengerListWithTravellers();
    setPassengerList(passengerListMapped);
  }, []);

  const extrasCallStatus = useRef(false);
  useEffect(() => {
    if (currentStep === 0 && passengerList.length) {
      const cuerpoDeparture: Array<Array<BodyExtrasObj>> = _mapBodyExtraData(tripSelectedDetails?.aveDeparture);
      const cuerpoReturn: Array<Array<BodyExtrasObj>> = _mapBodyExtraData(tripReturnSelectedDetails?.aveReturn);

      if (extrasCallStatus.current === false) {
        if (cuerpoDeparture.length > 0) {
          setBookingsExtrasCall(cuerpoDeparture,
            (response: Array<{ data: ResponseExtrasCall, status: number }>) => {
              setDepartureResponseExtrasList(response);

              const filtered: TariffsExtras[][] = response.map(element => element.data?.tariffs);
              const tariffs: Array<TariffsExtras> = [];

              filtered.forEach((trenes: TariffsExtras[]) => {
                trenes.forEach((tren: TariffsExtras) => tariffs.push(tren))
              })
              extrasCardMapSection(tariffs, 'departure');
            },
            (e: any) => {
              if (cuerpoDeparture.length > 0) {
                extrasCardMapSection([], 'departure');
              }

            });
        }
        if (cuerpoReturn.length > 0) {
          setBookingsExtrasCall(cuerpoReturn,
            (response: Array<{ data: ResponseExtrasCall, status: number }>) => {
              setReturnResponseExtrasList(response);

              const filtered: TariffsExtras[][] = response.map(element => element.data?.tariffs);
              const tariffs: Array<TariffsExtras> = [];

              filtered.forEach((trenes: TariffsExtras[]) => {
                trenes.forEach((tren: TariffsExtras) => tariffs.push(tren))
              })
              extrasCardMapSection(tariffs, 'return');
            },
            (e: any) => {
              if (cuerpoReturn.length > 0) {
                // extrasCardMapSection([], 'departure'); aqui ponia departure lo he cambiado por return
                extrasCardMapSection([], 'return');
              }
            });
        }
        extrasCallStatus.current = true;
      }
    }
    if (currentStep === 3) {
      resumeStepMapSection();
    }
  }, [currentStep, passengerList]);

  useEffect(() => {
    if (!emptyArray(departureResponseExtrasList)) {
      const tariffsExtras: TariffsExtras[][] = departureResponseExtrasList.map((extra: any) => extra.data?.tariffs);
      const payedPassenger = tripSelectedDetails?.aveDeparture?.payedPassengerNumber;
      const seatList = _getSeatList(tariffsExtras, payedPassenger);
      setDepartureSeatComplementList(seatList);
    }

  }, [departureResponseExtrasList]);

  useEffect(() => {
    if (!emptyArray(returnResponseExtrasList)) {
      const tariffsExtras: TariffsExtras[][] = returnResponseExtrasList.map((extra: any) => extra.data?.tariffs);
      const payedPassenger = tripReturnSelectedDetails?.aveReturn?.payedPassengerNumber;
      const seatList = _getSeatList(tariffsExtras, payedPassenger);
      setReturnSeatComplementList(seatList);
    }

  }, [returnResponseExtrasList]);

  useEffect(() => {
    if (!emptyArray(departureComplementList)) {
      getSeatTrainMap(departureComplementList,
        (response: Array<{ data: any }>) => {
          seatingDepartureSectionMap(response);
          setSeatingDeparture(response)
        },
        (e: any) => console.log('error', e));
    }
  }, [departureComplementList]);

  useEffect(() => {
    if (!emptyArray(returnComplementList)) {
      getSeatTrainMap(returnComplementList,
        (response: Array<{ data: any }>) => {
          seatingReturnSectionMap(response);
          setSeatingReturnSection(response)
        },
        (e: any) => console.log('error', e));
    }
  }, [returnComplementList]);

  const _getSeatList = (tariffsExtras: any, payedPassengerNumber: number) => {
    return tariffsExtras?.map((element: any, index: number) => {

      return element?.map((comp: any) => {
        const posibleSeatChoose = comp?.complements?.find((complement: any) => complement?.codComplement === "SEAT");
        let seatListOpction = mapFreeSeatOption();
        const totalPrice = +posibleSeatChoose?.price * payedPassengerNumber;

        const seatObject = {
          title: t("literals.seatSelection"),
          priceText: formatPrice(+posibleSeatChoose?.price) + " €",
          price: +totalPrice.toFixed(2),
          singlePrice: +posibleSeatChoose?.price,
          id: posibleSeatChoose?.codComplement,
          description: t("literals.seatDescriptionCard"),
          descriptionPrice: t("literals.seatDescriptionPrice"),
          seatMaxSelect: payedPassengerNumber,
          isValid: false
        }

        !!posibleSeatChoose && seatListOpction?.splice(1, 0, seatObject);
        return {
          tripId: index,
          context: !!posibleSeatChoose ? comp?.context : null,
          seatListOpction: seatListOpction,
        }
      });
    });
  }

  const mapFreeSeatOption = (): any => {

    const seatFreeListMapped = SeatingCardsList(t).map(item => {
      return {
        ...item,
        isValid: true
      }
    });
    return seatFreeListMapped;
  }

  const getAssociatedAdultObj = (userConnect: any) => {
    return {
      associatedAdultObj: {
        code: "CODE-0",
        selected: true,
        text: userConnect?.fullName,
        adultInfo: { phone: { phoneNumber: userConnect?.phoneNumber, prefixNumber: userConnect?.prefixNumber }, email: userConnect?.email }
      }
    }
  }

  const _mapRenfeHaeder = (item: any, aveSection: IAveDiscountCardSection) => {
    const aveSectionList = aveSection?.aveTripList || [];
    const firstElement = aveSectionList[0];
    const lastElement = aveSectionList?.slice(-1)[0];
    return {
      title: item?.title,
      aveId: item?.aveName,
      firstLocation: firstElement?.origin,
      middleLocation: firstElement?.direction,
      lastLocation: lastElement?.direction,
      isSilentCar: item?.isSilentCar
    }
  }

  const _getDiscountList = (item: any) => {

    return item?.discountList?.map((discount: any) => {
      const discountPrice = item?.tarifSelected?.price - discount?.price || 0;
      return {
        title: discount?.desc,
        description: `${formatPrice(discountPrice)} € ${t("literals.discountText")}`,
        discount: +discountPrice.toFixed(2),
        id: discount?.group?.discount,
        shpCtx: discount?.shpCtx
      }
    })
  }

  const isNegative = (num: number) => {
    return (Math.sign(num) === -1);
  }

  const _mapDiscountCardSection = (aveSection: IAveDiscountCardSection) => {
    return aveSection?.aveTripList?.map((item: any) => {
      const cardDiscountList = _getDiscountList(item);
      const notNegativeDiscount = cardDiscountList?.filter((item: any) => !isNegative(item?.discount));
      const discountCardsList = aveSection?.payedPassengerNumber >= 4 ? notNegativeDiscount : notNegativeDiscount?.filter((item: any) => item?.id !== EDiscoutCardEnum["4OMAS"]);
      const auxArray: { description: any; discount: any; id: any; shpCtx: any; title: any; }[]=[];
      discountCardsList.map((index: any) => {
        if(index.id==="DORADA" || index.id==="JOVEN" || index.id==="MASRENFE"){
          let aux = {
            description: index.description,
            discount: index.discount,
            id: index.id,
            shpCtx: index.shpCtx,
            title: mappingLiteralDiscounts(index.id, t),
          }
          auxArray.push(aux)
        }

      })
      return {
        renfeHeader: _mapRenfeHaeder(item, aveSection),
        cardsSection: {
          title: t("literals.discountTitleSection"),
          discountCardsList: auxArray
        }
      }
    });
  };

  const _mapSeatingCardSection = (aveSection: IAveDiscountCardSection, mapType: "departureSeating" | "returnSeating", response: any) => {

    const list = aveSection?.aveTripList?.map((item: any, index: number) => {

      const seatCardsList = emptyArray(response) ? mapFreeSeatOption() : response[index]?.seatListOpction || mapFreeSeatOption();
      return {
        renfeHeader: _mapRenfeHaeder(item, aveSection),
        cardsList: seatCardsList,
      }
    });

    return {
      type: mapType,
      seatingList: list
    }
  };

  const getPriceForPassenger = (passengerType: EPassengerFormVariant): number => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;

    const departureTicketSum = calculateSinglePrice(aveDepartureSection.summarySection.aveSummaryList, passengerType);
    const returnTicketSum = aveReturnSection?.isAveSelected ? calculateSinglePrice(aveReturnSection.summarySection.aveSummaryList, passengerType) : 0;

    const total = departureTicketSum + returnTicketSum;
    return total;
  };

  const discountCardMapSection = () => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;
    const departure = aveDepartureSection?.isAveSelected
      ? _mapDiscountCardSection(aveDepartureSection)
      : [];
    const returnTrip = aveReturnSection?.isAveSelected
      ? _mapDiscountCardSection(aveReturnSection)
      : [];
    setDepartureDiscountCard(departure);
    setReturnDiscountCard(returnTrip);

  };

  const familyCardDiscountMapSection = (passengerType: EPassengerFormVariant) => {

    const totalPriceForPassenger = getPriceForPassenger(passengerType);
    const generalDiscount = totalPriceForPassenger * generalFamilyCard(t)?.percentageDiscount / 100;
    const specialDiscount = totalPriceForPassenger * specialFamilyCard(t)?.percentageDiscount / 100;

    const generalCard = {
      ...generalFamilyCard(t),
      discountAllTrainForPerson: +generalDiscount.toFixed(2) || 0,
    }
    const specialCard = {
      ...specialFamilyCard(t),
      discountAllTrainForPerson: +specialDiscount.toFixed(2) || 0,
    }

    return {
      generalCard,
      specialCard
    }

  };

  const extrasCardMapSection = (response: Array<TariffsExtras>, trip: 'departure' | 'return') => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;
    let tripData;
    if (trip === 'departure') {
      tripData = aveDepartureSection?.isAveSelected
        ? _mapExtrasCardSection(aveDepartureSection, response, 'departureSeating')
        : {};
        
      setDepartureExtrasCard(tripData);
    }
    else if (trip === 'return') {
      tripData = aveReturnSection?.isAveSelected
        ? _mapExtrasCardSection(aveReturnSection, response, 'returnSeating')
        : {};

      setReturnExtrasCard(tripData);
    }
    // const pasajeros = _mapPassengers();
    // setPassengersExtrasCard(pasajeros);
  }

  const _mapBodyExtraData = (aveSection: IAveDiscountCardSection): Array<Array<BodyExtrasObj>> => {
    const listShpCtx = aveSection?.aveTripList?.map((item: any) => item.tarifSelected?.shpCtx);


    const tariffs: Array<Array<BodyExtrasObj>> = [];
    listShpCtx?.forEach((context: string) => {
      !!context && tariffs.push([{ passengerType: 'A', context }]);
    })
    return tariffs
  }

  const _mapExtrasCardSection = (aveSection: IAveDiscountCardSection, response: Array<TariffsExtras>, mapType: string) => {
    const list = aveSection?.aveTripList?.map((item: any) => {
      const shpCtx = item?.tarifSelected?.shpCtx;
      const cardsByshpCtx = (response || []).find(item => item.context === shpCtx);
      return {
        renfeHeader: _mapRenfeHaeder(item, aveSection),
        cardsSection: cardsByshpCtx?.complements ? cardsByshpCtx.complements : []
      }
    });

    return {
      type: mapType,
      seatingList: list
    }
  }

  const _mapPassengers = (arrayPassengers: Array<any>) => {
    return arrayPassengers.map(item => item.passengerName);
  }

  const seatingDepartureSectionMap = (deapartureResponse: any) => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const departure = aveDepartureSection?.isAveSelected
      ? _mapSeatingCardSection(aveDepartureSection, "departureSeating", deapartureResponse)
      : {};
    setDepartureSeating(departure);
  };

  const seatingReturnSectionMap = (returnResponse: any) => {
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;;
    const returnTrip = aveReturnSection?.isAveSelected
      ? _mapSeatingCardSection(aveReturnSection, "returnSeating", returnResponse)
      : {};
    setReturnSeating(returnTrip);
  };



  const getSummaryTopSection = (departureAveSection: IAveDiscountCardSection, returnAveSection: IAveDiscountCardSection) => {
    const firstItem = departureAveSection?.summarySection?.aveSummaryList[0];
    const lastItem = departureAveSection?.summarySection?.aveSummaryList.slice(-1)[0];

    const returnDate = returnAveSection?.isAveSelected ? returnAveSection?.summarySection?.aveSummaryList[0].returnDate : "";

    return {
      departure: firstItem?.origin,
      return: lastItem?.direction,
      passengerNumber: firstItem?.allPassangerNum,
      departureDate: firstItem?.departureDate,
      returnDate: returnDate
    }
  }

  const getTotalOtherTransportPrice = (departureAveSection: IAveDiscountCardSection, returnAveSection: IAveDiscountCardSection): number => {
    const departure: number = departureAveSection?.summarySection?.otherTransportPrice
    const returnTrip: number = returnAveSection?.isAveSelected ? returnAveSection?.summarySection?.otherTransportPrice : 0;
    return (departure + returnTrip)
  }

  const calculateTotalTrainPrice = (array: any) => {
    const initialValue = 0;
    const sumWithInitial = array?.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.allPassengerTicketPrice, initialValue);

    return sumWithInitial;
  }

  const getTicketPriceDefault = (departureAveSection: IAveDiscountCardSection, returnAveSection: IAveDiscountCardSection) => {

    const departureTicketSum = calculateTotalTrainPrice(departureAveSection.summarySection.aveSummaryList);
    const returnTicketSum = returnAveSection?.isAveSelected ? calculateTotalTrainPrice(returnAveSection.summarySection.aveSummaryList) : 0;
    const total = departureTicketSum + returnTicketSum;


    return [{
      text: t("literals.trainTickets"),
      price: total,
      priceText: `${formatPrice(total)} €`,
      id: "ticketPrice"
    }]
  }

  const makePointCardResumeObject = (pointCard: any) => {
      return {
        id: 'RENFE+',
        name: t("passengerStepLiteralsPage.discountSection.pointSectionCard.title"),
        body: {
          type: "RENFE+",
          value: `${pointCard.value}`
        }
      }
  }
  const makeDiscountCardResumeObject = (discountSelectedForm: any) => {
    const discoutSelected = discountSelectedForm?.selectedValue?.cardSelectedType?.value;
    const cardSelectedNumber = discountSelectedForm?.selectedValue?.cardNumber?.value;
    if(discoutSelected?.id==="JOVEN"){
      return {
        id: discoutSelected?.id,
        name: discoutSelected?.title,
        ammount: discoutSelected?.discount,
        shpCtxSelected: discoutSelected?.shpCtx,
      }
    }else{
      return {
        id: discoutSelected?.id,
        name: discoutSelected?.title,
        ammount: discoutSelected?.discount,
        shpCtxSelected: discoutSelected?.shpCtx,
        body: {
          type: "DISCOUNT_CARD",
          value: `${discoutSelected?.id};${cardSelectedNumber}`
        }
      }
    }
  

  }

  const makeFamilyCardDiscountResumeObject = (discountFamilyCardForm: any, ticketTariffPrice: number) => {

    const discoutSelected = discountFamilyCardForm?.cardSelectedType?.value;
    const cardSelectedNumber = discountFamilyCardForm?.familyCardNumber?.value;
    const autonomousCommunity = discountFamilyCardForm?.autonomousCommunity?.value;
    const discount = discoutSelected?.percentageDiscount * ticketTariffPrice / 100;
    const autonomousCode = autonomousCommunity?.extraData?.backCode;
    const discoutSelectedId: 'GENERAL' | 'ESPECIAL' = discoutSelected?.id;
    // ENVIAMOS EL ID Y NO EL CODIGO DE LA TABLA (CAMBIO DE BACK) (MASRENFE|DORADA)
    // const familyCardCode = ELargeFamilyCardEnum[discoutSelectedId];
    return {
      id: discoutSelected?.id,
      name: t("literals.largeFamily"),
      ammount: discount,
      body: {
        type: "LARGE_FAMILY_CARD",
        value: `${discoutSelectedId};${cardSelectedNumber};${autonomousCode}`
      }
    }
  }

  const getDiscountArray = (item: any, discountCardKey: string, ticketTariffPrice: number, tripIndex: number) => {
    let discountList = [];
    const discountIsOpen = item?.discountData?.isOpenDiscountSection;

    /* Tarjeta puntos */
    const pointCard = item?.discountData?.pointCardNumber;
    const pointCardFilled = !!item?.discountData?.pointCardNumber?.value;
    (pointCardFilled && discountIsOpen) && discountList.push(makePointCardResumeObject(pointCard));
    /* Tarjeta de descuentos */
    const discountCardSection = item?.discountData?.discountCardForm;
    const isDiscountCardSelected = item?.discountData?.isOpenCardDiscountSection;
    (isDiscountCardSelected && discountIsOpen) && discountList.push(makeDiscountCardResumeObject(discountCardSection[discountCardKey][tripIndex]));
    /* Familia numerosa */
    const discountFamilyCardSection = item?.discountData?.familyCardSection;
    const isDiscountFamilyCardSelected = item?.discountData?.isOpenFamilyCardSection;
    (isDiscountFamilyCardSelected && discountIsOpen) && discountList.push(makeFamilyCardDiscountResumeObject(discountFamilyCardSection, ticketTariffPrice));

    discountList.length === 0 && discountList.push(EmptyDiscountState(t));
    return discountList;
  }

  const getSeatingBodyValue = (elementSelected: any, passengerIndex: number): string => {
    const seatingId: ESeatingTypes = elementSelected?.id;
    let value = "";
    switch (seatingId) {
      case ESeatingTypes.SEAT:
        const seatSelectedObject = elementSelected?.seatSelectedList[passengerIndex];
        value = `${seatSelectedObject?.carCode};${seatSelectedObject?.text}`
        break;
      case ESeatingTypes.CHOISE_WINDOW:
        value = "PREF-W"
        break;
      case ESeatingTypes.CHOISE_HALLWAY:
        value = "PREF-H"
        break;
      default:
        value = ""
        break;
    }
    return value;
  }

  const getSeatingExtraSelected = (elementSelected: any, passengerIndex: number) => {
    const seatValue = getSeatingBodyValue(elementSelected, passengerIndex);
    const bodyArray = !!seatValue ? [{
      type: "CHOICE_SEAT",
      value: seatValue
    }] : [];
    elementSelected?.id === ESeatingTypes.SEAT && bodyArray?.push({ type: "SEAT", value: "1" })

    return {
      id: elementSelected?.id,
      name: `${t("literals.seatSelectionResume")} ${parseFloat(elementSelected?.price) === 0 ? t("literals.freeParentheses") : ''}`,
      ammount: elementSelected?.id === ESeatingTypes.SEAT ? elementSelected?.singlePrice : elementSelected?.price,
      body: bodyArray,
      type:"CHOICE_SEAT"
    }
  }

  const getSeatingResume = (tripIndex: number, passengerIndex: number, isDepartureSection: boolean): Array<any> => {
    const key = isDepartureSection ? "departureSectionData" : "returnSectionData";
    const elementSelected = seatingSelected[key];
    let seatingExtra: Array<ISeatData> = [];
    if (elementSelected) {
      seatingExtra = [getSeatingExtraSelected(elementSelected[tripIndex], passengerIndex)]
    }
    return seatingExtra;
  }

  const getExtrasResume = (tripIndex: number, passengerId: string, isDepartureSection: boolean): Array<any> => {
 
    const key = isDepartureSection ? "departureSectionData" : "returnSectionData";
    const elementSelected = extraSelected[key]?.extrasSelected;
    let seatingExtra: Array<ExtraData> = [];
    if (elementSelected ) {
      seatingExtra = getInverseData(tripIndex, passengerId, elementSelected, isDepartureSection ? departureExtrasCard : returnExtrasCard);
    }
    return seatingExtra;
  }

  const getInverseData = (tripIndex: number, passengerId: string, elementSelected: Array<ExtraSelectedObject>, extrasList: TripList): Array<ExtraData> => {
    const info: Array<ExtraData> = [];
    elementSelected.forEach((_elementSelected: any, _indexSelectedList: number) => {
      if (_elementSelected.passengers.includes(passengerId)) {
        const extraInfo = extrasList.seatingList?.[tripIndex]?.cardsSection?.filter((item: any) => item.codComplement === _elementSelected.extra);
       
       
        (extraInfo || []).forEach(data => {
          info.push({
            tripIndex:tripIndex,
            id: data.codComplement,
            name: `${data.nameComplement} ${parseFloat(data.price) === 0 ? t("literals.freeParentheses") : ''}`,
            ammount: parseFloat(data.price),
            body: {
              type: data.codComplement,
              value: '1'
            }
          })
        })
      }
    });

    return info;
  }

  const getPassengerTypeLiteral = (type: "ADULT" | "CHILD" | "BABY") => {
    return passengerTypeLiterals(t)[type] || passengerTypeLiterals(t).ADULT;
  }

  const mapResumePassangersList = (discountCardKey: string, adultPrice: number, childPrice: number, childShpCtx: string, isDepartureSection: boolean, tripIndex: number) => {
    const passengerResume = passengerList?.map((item: any, passIndex: number) => {
      const passengerId = `id-${passIndex}`;
      const isBaby = item?.accordionId === "BABY";
      const isChild = item?.accordionId === "CHILD";
      const passengerLiteral = getPassengerTypeLiteral(item?.accordionId);
      const ticketTariffPrice = isBaby ? 0.00 : isChild ? childPrice : adultPrice;
      const discountSectionArray = getDiscountArray(item, discountCardKey, ticketTariffPrice, tripIndex);
      const seatSelectedExtra = isBaby ? [null] : getSeatingResume(tripIndex, passIndex, isDepartureSection);
      const extras = isBaby ? [null] : getExtrasResume(tripIndex, passengerId, isDepartureSection);

      const extrasAndSeating = seatSelectedExtra.concat(extras);

      return {
        id: item?.accordionId,
        ticketPrice: ticketTariffPrice,
        childShpCtx,
        passengerInfo: {
          fullName: item?.passengerName,
          passengerType: passengerLiteral,
        },
        discountSection: discountSectionArray,
        extraSection: extrasAndSeating?.length === 0 ? [EmptyExtrasState(t)] : extrasAndSeating.filter(Boolean)
      }
    })
    return passengerResume;
  }


  const getResumeHeaderSection = (aveSummaryList: any, sectionType: "departureSection" | "returnSection") => {
    const isDepartureSection = sectionType === "departureSection";
    return (aveSummaryList || []).map((item: any, index: number) => {
      const discountKey = sectionType === "departureSection" ? "departure" : "return";
      let  adultPrice=0.00
      if(item?.bonoAveFree===false || item?.bonoAveFree===undefined ){
        adultPrice= item?.adultTarif?.price 
      }
      const childPrice = item.childTarif?.price || adultPrice || 0.00;
      const childShpCtx = item.childTarif?.shpCtx || null;

      return {
        id: `code-${index}`,
        renfeHeader: {
          aveId: item?.aveName,
          firstLocation: item?.origin,
          middleLocation: item?.direction,
          lastLocation: '',
          travelDate: getDepartureDate(item?.fullDepartureDate),
          departureTime: item?.departureTime,
          arrivalTime: item?.arrivalTime,
          isSilentCar: item?.isSilentCar,
        },
        passengerList: mapResumePassangersList(discountKey, adultPrice, childPrice, childShpCtx, isDepartureSection, index)
      }
    })
  }

  const _getSummaryWithAveMap = (summary: any,tripSelected: any, resumeSection: any, typeAve:String) => {
    let prices = [] as any
    let pricesExtra = [] as any
    let pricesAveDiscounted = [] as any
    let sumaTotalDescuentos=0,sumaTotalViaje=0, getTripsNoAve=0,  getTripsNoAveExterno=0;
    let sumaTotalExtra=0
    if(typeAve==="departure"){
      tripSelected.aveDeparture?.aveTripList?.map((item: any, index: number) => {
        const passengerList = resumeSection[index].passengerList;
        const sumPrice = _calculateTotalSumPrice(passengerList,item.priceTag.price);
        const extrasList = passengerList?.map((item: any) => item?.extraSection).flat(1);
        
        const discountList = passengerList?.map((item: any) => item?.discountSection).flat(1);
        const extrasSum = _calculateTotalTrainPrice(extrasList);
  
        const totalExtrasPlusPrice = sumPrice + extrasSum;
        const discountSum = _calculateTotalTrainPrice(discountList);
        pricesExtra.push(extrasSum)
        
        prices.push(totalExtrasPlusPrice);
        pricesAveDiscounted.push(discountSum)
      })
       sumaTotalDescuentos= pricesAveDiscounted.reduce((anterior: any, actual: any) => anterior + actual, 0);
       sumaTotalViaje= prices.reduce((anterior: any, actual: any) => anterior + actual, 0);
      let routes=tripSelected?.summaryAmount?.departure?.transports;
      getTripsNoAve=0;
      getTripsNoAveExterno=0;
      sumaTotalExtra+= pricesExtra.reduce((anterior: any, actual: any) => anterior + actual, 0);

      //Obtenemos todos los precios de todas las rutas que no sea de ave
      if(routes){

        routes.map((item: any) =>  {
          if(item.transport.includes('AVE') || item.transport.includes('AVANT')|| item.transport.includes('RENFE')){
        }else{
          if(item?.price){
            if(item?.price.includes('aprox.')){
              getTripsNoAve+=pricesConverter(item?.price.substring(7))
            }else if(item?.isIncluding===true){
              getTripsNoAve+=0
            }
            else{
              getTripsNoAve+=pricesConverter(item?.price)
            }
            
          }else{
            if(item?.details[0]?.price.includes('€')){
              if(item?.details[0].external==true){
                getTripsNoAve+=0
                getTripsNoAveExterno+=pricesConverter(item?.details[0]?.price)
              }else{
                getTripsNoAve+=pricesConverter(item?.details[0]?.price)
              }
              
            }else{
              getTripsNoAve+=0
            }
          
          }
         
        }
         })
        }
    }else{
      tripSelected.aveReturn?.aveTripList?.map((item: any, index: number) => {
        const passengerList = resumeSection[index].passengerList;
        const sumPrice = _calculateTotalSumPrice(passengerList,item.priceTag.price);
        const extrasList = passengerList?.map((item: any) => item?.extraSection).flat(1);
        
        const discountList = passengerList?.map((item: any) => item?.discountSection).flat(1);
        const extrasSum = _calculateTotalTrainPrice(deleteDuplicateArray(extrasList));
  
        const totalExtrasPlusPrice = sumPrice + extrasSum;
        const discountSum = _calculateTotalTrainPrice(discountList);
  
        pricesExtra.push(extrasSum)
        prices.push(totalExtrasPlusPrice);
        pricesAveDiscounted.push(discountSum)
      })
       sumaTotalDescuentos= pricesAveDiscounted.reduce((anterior: any, actual: any) => anterior + actual, 0);
       sumaTotalViaje= prices.reduce((anterior: any, actual: any) => anterior + actual, 0);

      let routes=tripSelected?.summaryAmount?.arrival?.transports;
      getTripsNoAve=0;
      getTripsNoAveExterno=0;
      sumaTotalExtra+= pricesExtra.reduce((anterior: any, actual: any) => anterior + actual, 0);
      //Obtenemos todos los precios de todas las rutas que no sea de ave
      if(routes){

        routes.map((item: any) =>  {
          if(item.transport.includes('AVE') || item.transport.includes('AVANT') || item.transport.includes('RENFE')){
        }else{
          if(item?.price){
            if(item?.price.includes('aprox.')){
              getTripsNoAve+=pricesConverter(item?.price.substring(7))
            }else if(item?.isIncluding===true){
              getTripsNoAve+=0
            }
            else{
              getTripsNoAve+=pricesConverter(item?.price)
            }
            
          }else{
            if(item?.details[0]?.price.includes('€')){
              if(item?.details[0].external==true){
                getTripsNoAve+=0
                getTripsNoAveExterno+=pricesConverter(item?.details[0]?.price)
              }else{
                getTripsNoAve+=pricesConverter(item?.details[0]?.price)
              }
              
            }else{
              getTripsNoAve+=0
            }
          
          }
         
        }
         })
        }
    }
  
    return (summary || [])?.map((item: Summary) => {
      return {
        ...item,
        price: `${formatPrice((sumaTotalViaje-sumaTotalDescuentos)+getTripsNoAve)} €`,
        priceNumber: (sumaTotalViaje-sumaTotalDescuentos)+getTripsNoAve 
        
      }
    })
  }


  const saveSelectedTariffDepartureBody = () => {
    const outwardJourney = tripSelectedDetails?.body?.outwardJourney;
    const summary = tripSelectedDetails?.summary;
    const sumsObject = _getExtrasAndDiscountSum(resumeDepartureSection);

    const tripSummaryDetails: ITripSelectedDetails = {
      ...tripSelectedDetails,
      body: {
        ...tripSelectedDetails.body,
        outwardJourney: {
          trip: outwardJourney?.trip as Trip,
          selectedTariff: makeSelectedTariff(outwardJourney?.selectedTariff, resumeDepartureSection),
        },
      },
      summary: _getSummaryWithAveMap(summary, tripSelectedDetails, resumeDepartureSection,"departure"),
      summaryAmount: getSummaryDepartureAmount(tripSelectedDetails, sumsObject, resumeDepartureSection, summary)
    };
    //extraSelected

    setTripSelectedDetails(tripSummaryDetails);
    setTripSummaryDetail(tripSummaryDetails);

  };


  const _calculateTotalTrainPrice = (array: any) => {
    const initialValue = 0;
    const sumWithInitial = array?.reduce((previousValue: any, currentValue: any) => previousValue + currentValue?.ammount || 0, initialValue);
    return sumWithInitial;
  }

  const _getExtrasAndDiscountSum = (resumeSection: any): { extrasSum: number, discountSum: number } => {
    const passengerList = resumeSection?.map((item: any) => item?.passengerList);
    
    const extrasList = passengerList?.flat(1).map((item: any) => item?.extraSection).flat(1);
    const discountList = passengerList?.flat(1).map((item: any) => item?.discountSection).flat(1);
    const extrasSum = _calculateTotalTrainPrice(extrasList);
    const discountSum = _calculateTotalTrainPrice(discountList);

    return {
      extrasSum,
      discountSum
    }
  }

  const _calculateTotalSumPrice = (array: any, price?:Number) => {
    let sumWithInitial=0
    if(price!==0){
    const initialValue = 0;
    sumWithInitial = array?.reduce((previousValue: any, currentValue: any) => previousValue + currentValue?.ticketPrice || 0, initialValue);
  }
    return sumWithInitial;
  }
  const getSummaryDepartureAmount = (tripSelected: any, sums: any, resumeSection: any, summary: any) => {
    let auxExtra={
      departureSectionData:{
        extrasSelected: {},
        isValidSection: true,
        type: "departureSeating"
    }
  }
    if(seatingSelected?.departureSectionData.length!=0){
      if(extraSelected.departureSectionData!=undefined  ){
      let aux=extraSelected.departureSectionData.extrasSelected
      seatingSelected?.departureSectionData.map((item: any, index: number)=> {
        let y={
          extra:item?.id,
          totalPrice:item?.price,
          index:index
        }
        aux.push(y)
      });
      setExtraSelected(aux)
      //No hay extras metemos el asiento como si fuera un extra
    }else{
      let aux=[] as any
      seatingSelected?.departureSectionData.map((item: any, index: number)=> {
        let y={
          extra:item?.id,
          totalPrice:item?.price,
          index:index}
        aux.push(y)
      });
     auxExtra={
        departureSectionData:{
        extrasSelected: aux,
        isValidSection: true,
        type: "departureSeating"
       }   
      }        
     }
    }

    let prices = [] as any
    let pricesExtra = [] as any
    let pricesAveDiscounted = [] as any
    let preciosDescuentos = [] as any
    tripSelected.aveDeparture?.aveTripList?.map((item: any, index: number) => {
      const passengerList = resumeSection[index].passengerList;
      const sumPrice = _calculateTotalSumPrice(passengerList,item.priceTag.price);
      const extrasList = passengerList?.map((item: any) => item?.extraSection).flat(1);

      const discountList = passengerList?.map((item: any) => item?.discountSection).flat(1);
      discountList.map((item: any) => {
        if(item.id!=='ESPECIAL'||item.id!=='GENERAL'){
          preciosDescuentos.push({
            idTrip:index,
            price:`-${formatPrice(item.ammount)} €`,
            id: item.id,
            description:item.id ==="ESPECIAL" ||item.id ==="GENERAL" ?item.name: item.id,
            info:''
          }
          )
        }
      
      }).flat(1);
  
   
      const extrasSum = _calculateTotalTrainPrice(extrasList);
      const totalExtrasPlusPrice = sumPrice /*+ extrasSum*/;
      const discountSum = _calculateTotalTrainPrice(discountList);
    
      prices.push(totalExtrasPlusPrice);
      pricesExtra.push(extrasSum)
      pricesAveDiscounted.push(discountSum)
    })
    
    let sumaTotalDescuentos= pricesAveDiscounted.reduce((anterior: any, actual: any) => anterior + actual, 0);
 
    let sumaTotalViaje= prices.reduce((anterior: any, actual: any) => anterior + actual, 0);
    let routes=tripSelected?.summaryAmount?.departure?.transports;
    let TripPre=0;
    let tripExterno=0;
    let tripPost=0;

   //Obtenemos todos los precios de prices las rutas que no sea de ave
    if(routes){
    routes.map((item: any) =>  {
      if(!item.transport.includes('AVE') && !item.transport.includes('AVANT') && !item.transport.includes('RENFE')){   
        if(item?.price){
            if(item?.price.includes('aprox.')){
                tripPost+=pricesConverter(item?.price)
            }else if(item?.isIncluding===true){
                TripPre+=0
            }
            else{
                TripPre+=pricesConverter(item?.price)
            }
            
        }else{
            if(item?.details[0]?.price.includes('€')){
                if(item?.details[0].external){
                    TripPre+=0
                    tripExterno+=pricesConverter(item?.details[0]?.price)
                }else{
                    TripPre+=pricesConverter(item?.details[0]?.price)
                }
            
            }else{
                TripPre+=0
            }        
        }     
    }
     })
    }

    let sumaTotalExtra= pricesExtra.reduce((anterior: any, actual: any) => anterior + actual, 0);
    let count = 0;
    let extrasRecorrer={} as any
    if(extraSelected?.departureSectionData?.extrasSelected){
      extrasRecorrer=extraSelected?.departureSectionData?.extrasSelected;
    }else if(auxExtra?.departureSectionData.extrasSelected){
      extrasRecorrer=auxExtra?.departureSectionData.extrasSelected
    }
    
    return {
      departure: {
        ...tripSelected.summaryAmount.departure,
        desglose: {
          ...tripSelected.summaryAmount.departure.desglose,
        totalAux:`${formatPrice(((sumaTotalViaje-sumaTotalDescuentos)+sumaTotalExtra) + TripPre + tripExterno + tripPost)} €`,
          now: tripSelected.aveDeparture.isAveSelected ? 
          `${formatPrice((sumaTotalViaje-sumaTotalDescuentos)+sumaTotalExtra+TripPre)} €`
           : `${formatPrice((sumaTotalViaje-sumaTotalDescuentos)+sumaTotalExtra+TripPre)} €`, 
          total: `${formatPrice(((sumaTotalViaje-sumaTotalDescuentos)+sumaTotalExtra)+ TripPre + tripExterno + tripPost)} €`
        },

        transports: tripSelected.summaryAmount.departure.transports.map((item: any) => {
          const discount = pricesAveDiscounted[count];
          if (item?.details?.[0]?.icon?.includes('ave')) {
            let copyDetail = item.details[0];
            let extrasPst=extrasRecorrer.map((item: any) => {
              if(item.index===count){
                return item.totalPrice
              }else{
                return 0
              }})
        let extrasPstTotal=extrasPst.reduce((anterior: any, actual: any) => anterior + actual, 0)
            item = {
              ...item,
              //price:`${formatPrice(((pricesConverter(item?.details[0].price)-sumaTotalDescuentos)+extrasPstTotal))} €`,
              price:`${formatPrice(((pricesConverter(item?.details[0].price)-pricesAveDiscounted[count])+extrasPstTotal))} €`,
              details: [
                {
                  ...copyDetail,
                  price: `${formatPrice(prices[count])} €`,
                  ...{descriptionSection: preciosDescuentos?.filter((item: any,) => {
                    if(item.idTrip===count){
                      return {
                        idTrip:item.idTrip,
                        info:'',
                        description:item.description,
                        id:item.id,
                        price:`-${formatPrice(item.price)} €`
                        //price:item.id==="discount"? `-${formatPrice(discount)} €`:`-${formatPrice(item.price)} €`
          
                      }
                    }
                   
                  })},
                  
                  ...{extraSelected: extrasRecorrer?.map((item: any) => {
                    if(item.index===count){
                    return {
                      description:literalExtrasConverter(item.extra,t),
                      id:item.extra,
                      price:`+${formatPrice(item.totalPrice)} €`
                    }
                  }
                  })}
                  
                }]
            }
            ++count
          }
          return {
            ...item
          }
        })
      },
      arrival: {}
    }
  }

  const getSummaryArrivalAmount = (tripSelectedReturn: any, sums: any, resumeSection: any, summary: any) => {
    let auxExtra={
      returnSectionData:{
        extrasSelected: {},
        isValidSection: true,
        type: "departureSeating"
    }
  }
  
    if(seatingSelected?.returnSectionData.length!=0){
      if(extraSelected.returnSectionData!=undefined  ){
      let aux=extraSelected.returnSectionData.extrasSelected
      seatingSelected?.returnSectionData.map((item: any, index: number)=> {
        let y={
          extra:item?.id,
          totalPrice:item?.price,
          index:index
        }
        aux.push(y)
      });
      setExtraSelected(aux)
      //No hay extras metemos el asiento como si fuera un extra
    }else{
      let aux=[] as any
      seatingSelected?.returnSectionData.map((item: any, index: number)=> {
        let y={
          extra:item?.id,
          totalPrice:item?.price,
          index:index}
        aux.push(y)
      });
     auxExtra={
      returnSectionData:{
        extrasSelected: aux,
        isValidSection: true,
        type: "returnSeating"
      }   
    } 
    }

    }
    let prices = [] as any
    let pricesExtra = [] as any
    let pricesAveDiscounted = [] as any
    let preciosDescuentos = [] as any
    tripSelectedReturn.aveReturn?.aveTripList?.map((item: any, index: number) => {
      const passengerList = resumeSection[index].passengerList;
      const sumPrice = _calculateTotalSumPrice(passengerList,item.priceTag.price);
      const extrasList = passengerList?.map((item: any) => item?.extraSection).flat(1);
      
      const discountList = passengerList?.map((item: any) => item?.discountSection).flat(1);
      discountList.map((item: any) => {
        if(item.id!=='ESPECIAL'||item.id!=='GENERAL'){
          preciosDescuentos.push({
            idTrip:index,
            price:`-${formatPrice(item.ammount)} €`,
            id: item.id,
            description:item.id ==="ESPECIAL" ||item.id ==="GENERAL" ?item.name: item.id,
            info:''
          }
          )
        }
      
      }).flat(1);
      const extrasSum = _calculateTotalTrainPrice(extrasList);
      
      const totalExtrasPlusPrice = sumPrice;
      const discountSum = _calculateTotalTrainPrice(discountList);

      pricesExtra.push(extrasSum)
      prices.push(totalExtrasPlusPrice);
      pricesAveDiscounted.push(discountSum)
    })

   
    let sumaTotalDescuentos= pricesAveDiscounted.reduce((anterior: any, actual: any) => anterior + actual, 0);
    let sumaTotalViaje= prices.reduce((anterior: any, actual: any) => anterior + actual, 0);
    let routes=tripSelectedReturn?.summaryAmount?.arrival?.transports;
    let TripPre=0;
    let tripExterno=0;
    let tripPost=0;

    //Obtenemos todos los precios de prices las rutas que no sea de ave
    if(routes){
      routes.map((item: any) =>  {
        if(!item.transport.includes('AVE') && !item.transport.includes('AVANT') && !item.transport.includes('RENFE')){     
            if(item?.price){
                if(item?.price.includes('aprox.')){
                    tripPost+=pricesConverter(item?.price)
                  }else if(item?.isIncluding){
                    TripPre+=0
                }
                else{
                    TripPre+=pricesConverter(item?.price)
                }            
            }
            else {
                if(item?.details[0]?.price.includes('€')){
                    if (item?.details[0].external){
                        TripPre+=0
                        tripExterno+=pricesConverter(item?.details[0]?.price)
                    }
                    else {
                        TripPre+=pricesConverter(item?.details[0]?.price)
                    }                
                }
                else{
                    TripPre+=0
                }            
            }       
      }
       })
      }
    let sumaTotalExtra= pricesExtra.reduce((anterior: any, actual: any) => anterior + actual, 0);
    let count = 0;
    let extrasRecorrer={} as any
    if(extraSelected?.returnSectionData?.extrasSelected){
      extrasRecorrer=extraSelected?.returnSectionData?.extrasSelected;
    }else if(auxExtra?.returnSectionData.extrasSelected){
      extrasRecorrer=auxExtra?.returnSectionData.extrasSelected
    }
    return {
      departure: {
        // ...getSummaryDepartureAmount(tripSelectedDetails, _getExtrasAndDiscountSum(resumeDepartureSection), resumeSection, tripSelectedDetails?.summary).departure
      },
      arrival: {
        ...tripSelectedReturn.summaryAmount.arrival,
        desglose: {
          ...tripSelectedReturn.summaryAmount.arrival.desglose,
        totalAux:`${formatPrice(((sumaTotalViaje-sumaTotalDescuentos)+sumaTotalExtra) + TripPre + tripExterno + tripPost)} €`,
          now: tripSelectedReturn.aveReturn.isAveSelected ? 
          `${formatPrice((sumaTotalViaje-sumaTotalDescuentos) + sumaTotalExtra + TripPre)} €`
           : `${formatPrice((sumaTotalViaje-sumaTotalDescuentos) + sumaTotalExtra + TripPre)} €`,
          total: `${formatPrice(((sumaTotalViaje-sumaTotalDescuentos) + sumaTotalExtra)+ TripPre + tripExterno + tripPost)} €`
        },

        transports: tripSelectedReturn.summaryAmount.arrival.transports.map((item: any) => {
          const discount = pricesAveDiscounted[count];
          if (item?.transport.includes('AVE')) {
            let extrasPst=extrasRecorrer.map((item: any) => {
              if(item.index===count){
                return item.totalPrice
              }else{
                return 0
              }})
        let extrasPstTotal=extrasPst.reduce((anterior: any, actual: any) => anterior + actual, 0)
            let copyDetail = item.details[0];
            item = {
              ...item,
              price:`${formatPrice(((pricesConverter(item?.details[0].price)-sumaTotalDescuentos)+extrasPstTotal))} €`,
                details: [
                {
                  ...copyDetail,
                  price: `${formatPrice(prices[count])} €`,
                  ...{descriptionSection: preciosDescuentos?.filter((item: any,) => {
                    if(item.idTrip===count){
                      return {
                        idTrip:item.idTrip,
                        info:'',
                        description:item.description,
                        id:item.id,
                        price:`-${formatPrice(item.price)} €`
                        //price:item.id==="discount"? `-${formatPrice(discount)} €`:`-${formatPrice(item.price)} €`
          
                      }
                    }
                   
                  })},
                  ...{extraSelected: extrasRecorrer?.map((item: any) => {
                    if(item.index===count){
                      return {
                        description:literalExtrasConverter(item.extra,t),
                        id:item.extra,
                        price:`+${formatPrice(item.totalPrice)} €`
                      }
                    }
                  })}
                }]
            }
            ++count
          }
          return {
            ...item
          }
        })
      }
    }
  }


  const saveSelectedTariffReturnBody = () => {
    const summary = tripReturnSelectedDetails?.summary;
    const sumsObject = _getExtrasAndDiscountSum(resumeReturnSection);
    const returnJourney = tripReturnSelectedDetails?.body?.returnJourney;
    
    const tripReturnSummary: ITripSelectedDetails = {
      ...tripReturnSelectedDetails,
      body: {
        ...tripReturnSelectedDetails.body,
        returnJourney: {
          trip: returnJourney?.trip as Trip,
          selectedTariff: makeSelectedTariff(returnJourney?.selectedTariff, resumeReturnSection),
        }
      },
      summary: _getSummaryWithAveMap(summary, tripReturnSelectedDetails,resumeReturnSection,"return"),
      summaryAmount: getSummaryArrivalAmount(tripReturnSelectedDetails, sumsObject, resumeReturnSection, summary),
    };
    setReturnTripSelectedDetails(tripReturnSummary);
    setReturnTripSummaryDetail(tripReturnSummary);
  };

  const setAveBodyAndNavigateToResumeTrip = () => {
    
    tripSelectedDetails?.aveDeparture?.isAveSelected && saveSelectedTariffDepartureBody();
    tripReturnSelectedDetails?.aveReturn?.isAveSelected && saveSelectedTariffReturnBody();
    const params = new URLSearchParams(window?.location?.search); 
    const path = !!params.get('goBackTo') ? '/resume-route?goBackTo=/return-ave' : '/resume-route'; 
    navigate(path);
  }

  const getExtrasForPassangerList = (extrasList: any) => {
    const allExtrasBody = (extrasList || []).map((item: any) => item?.body);
    return allExtrasBody;
  }

  const getDiscountForPassangerList = (discountList: any) => {
    const allDiscontBody = (discountList || []).map((item: any) => item?.body);
    return allDiscontBody;
  }

  const makeSelectedTariff = (selectedTariffList: any, resumeSection: any): SelectedTariff[] => {
    const aveLegs = selectedTariffList.filter((item: SelectedTariff) => item?.provider === 'renfe-ave');
    const otherLegs = selectedTariffList.filter((item: SelectedTariff) => item?.provider !== 'renfe-ave') || [];
    const newAveMappedBody: SelectedTariff[] = aveLegs?.map((item: any, index: number) => {
      return {
        ...item,
        tickets: item?.tickets?.map((ticket: any, i: number) => {
          const isSilentCarSelected = resumeSection[index]?.renfeHeader?.isSilentCar;
          const passengerFiltredList = resumeSection[index]?.passengerList[i];
          const extrasList = getExtrasForPassangerList(passengerFiltredList.extraSection).filter(Boolean);
          const discountList = getDiscountForPassangerList(passengerFiltredList.discountSection).filter(Boolean);
          const discountSelected = passengerFiltredList?.discountSection?.find((discount: any) => !!discount?.shpCtxSelected);
          const extras = extrasList.concat(discountList);
          isSilentCarSelected && extras?.push({ type: "SILENT_CAR", value: "TRUE" });

          const shpCtx =
            passengerFiltredList.id === "CHILD"
              ? passengerFiltredList?.childShpCtx
              : discountSelected
                ? discountSelected?.shpCtxSelected
                : ticket?.context
                if(extras?.flat(1)?.[0]?.value===''){
                  return {
                    context: shpCtx,
                  }
                }else{
                  return {
                    context: shpCtx,
                  ...emptyArray(extras) ? {} : { extras: extras.flat(1) }
                  }
                }
        
        })
      }
    });

    const selectedTariff = !emptyArray(otherLegs) ? newAveMappedBody?.concat(otherLegs) : newAveMappedBody;
    const sortedArray = selectedTariff.sort((a: SelectedTariff, b: SelectedTariff) => a?.idLeg - b?.idLeg);
    return sortedArray;
  }

  const resumeStepMapSection = () => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;
    const departureResume = aveDepartureSection?.isAveSelected ? getResumeHeaderSection(aveDepartureSection?.summarySection?.aveSummaryList, "departureSection") : [];
    const returnResume = aveReturnSection?.isAveSelected ? getResumeHeaderSection(aveReturnSection?.summarySection?.aveSummaryList, "returnSection") : [];

    setResumeDepartureSection(departureResume);
    setResumeReturnSection(returnResume);

  };
  //Funciones de la modal travel-discount
  // const backDiscountApply = () => {
  //   setDiscountTravelsFlowModal(false)
  //   setDiscountPassengersFlowModal(true)
  // }

  const summaryMapSection = () => {
    const aveDepartureSection = tripSelectedDetails?.aveDeparture;
    const aveReturnSection = tripReturnSelectedDetails?.aveReturn;

    const totalOtherTransporPrice = getTotalOtherTransportPrice(aveDepartureSection, aveReturnSection);
    const topSectionInfo = getSummaryTopSection(aveDepartureSection, aveReturnSection);
    const ticketPriceDefault = getTicketPriceDefault(aveDepartureSection, aveReturnSection);

    const providersDepartureTrips = tripSelectedDetails?.body?.outwardJourney?.selectedTariff;
    const providersArrivalTrips = tripReturnSelectedDetails?.body?.outwardJourney?.selectedTariff;

    let showLiteralAprox = false; 

    providersDepartureTrips?.forEach(element => {
        if(element.provider.includes("karhoo") || element.provider.includes("bolt") || element.provider.includes("cooltra"))       
        showLiteralAprox = true;
    });

    providersArrivalTrips?.forEach(element => {
        if(element.provider.includes("karhoo") || element.provider.includes("bolt") || element.provider.includes("cooltra"))       
        showLiteralAprox = true;
    });
    setSummaryTopSection(topSectionInfo);
    setOtherTransportSumPrice(totalOtherTransporPrice);
    setPriceItemsList(ticketPriceDefault);

    setShowAproxLiteralSection(showLiteralAprox)

  };

  const mapPassengerListWithTravellers = (): IPassengerList[] => {
    const travellersList = tripSelectedDetails?.body?.travellers;
    const userConnect = getUserLoggedInfo();
    
    const mappedList: IPassengerList[] = (travellersList || []).map(
      (item, index): IPassengerList => {

        const familyDiscountCard = familyCardDiscountMapSection(item?.type);
        const isFirstElement = index === 0;
        return {
          userData: {
            email: isFirstElement ? userConnect?.email : "",
            name: isFirstElement ? userConnect?.name : "",
            surname: isFirstElement ? userConnect?.surname : "",
            surname2: isFirstElement ? userConnect?.surname2 : "",
            prefixNumber: isFirstElement ? userConnect?.prefixNumber : "",
            phoneNumber: isFirstElement ? userConnect?.phoneNumber : "",
            day: isFirstElement ? userConnect?.day : "",
            month: isFirstElement ? userConnect?.month : "",
            year: isFirstElement ? userConnect?.year : "",
            identificationDocument: isFirstElement
              ? userConnect?.identificationDocument
              : { type: "DNI", value: "" },
          },
          isValidForm: isFirstElement,
          isOpen: isFirstElement,
          passengerName: isFirstElement ? userConnect?.fullName : "",
          accordionId: item?.type,
          generalCard: familyDiscountCard?.generalCard,
          specialCard: familyDiscountCard?.specialCard,
          ...(isFirstElement ? getAssociatedAdultObj(userConnect) : {}),
        };
      }
    );

    return mappedList;
  };

  const getUserLoggedInfo = () => {
    const { customerFullName, birthDate, email, identificationDocument, phone } = userConnected;
    return {
      email,
      name: customerFullName && customerFullName.name,
      surname: customerFullName && customerFullName.firstSurname,
      fullName: customerFullName && `${customerFullName?.name} ${customerFullName?.firstSurname}`,
      surname2: customerFullName && customerFullName.secondSurname,
      prefixNumber: phone && phone.prefix.split('+')[1],
      phoneNumber: phone && phone.number,
      day: !!birthDate ? birthDate.split('-')[2] : '',
      month: !!birthDate ? birthDate.split('-')[1] : '',
      year: !!birthDate ? birthDate.split('-')[0] : '',
      identificationDocument
    }
  }

  const getDiscountCardValues = () => {
    const discountCardSum = getDiscountCardSum();
    const discountCardList =  passengerList?.map((value: any) => {

      const selectedValue = value?.discountData?.discountCardForm?.departure.find((item: any) => !!item?.selectedValue?.cardSelectedType?.value)?.selectedValue;

      if(selectedValue){

        const {cardSelectedType: {value: type}, cardNumber: {value: cardNumber}} = selectedValue;
        return {type, cardNumber}
      } else {
        return {};
      }
    });
    return {
      discountCard: discountCardList.find((item: any) => item.type),
      discountCardSum
    }
  }
  const getDiscountCardSum = () => {
    return passengerList?.reduce((previousValue: any, currentValue: any) => {
      const isValidAmmount = currentValue?.discountData?.isOpenDiscountSection && currentValue?.discountData?.isOpenCardDiscountSection;
      const current = isValidAmmount ? currentValue?.discountData?.discountCardForm?.discountCardTotal : 0;
      return previousValue + current
    }, 0);
  }

  const getFamilyCardDiscountSum = () => {
    return passengerList?.reduce((previousValue: any, currentValue: any) => {
      const isValidAmmount = currentValue?.discountData?.isOpenDiscountSection && currentValue?.discountData?.isOpenFamilyCardSection;
      const current = isValidAmmount ? currentValue?.discountData?.familyCardSection?.cardSelectedType?.value?.discountAllTrainForPerson : 0;
      return previousValue + current
    }, 0);
  }

  const getFamilyCardDiscountName = () => {
    return passengerList?.reduce((previousValue: any, currentValue: any) => {
      const isValidAmmount = currentValue?.discountData?.isOpenDiscountSection && currentValue?.discountData?.isOpenFamilyCardSection;
      //const nameDiscount = isValidAmmount ? currentValue?.discountData?.familyCardSection?.cardSelectedType?.value : t("literals.discounts");
      //Si no hay descuento por familia devolvemos array vacio
      const nameDiscount = isValidAmmount ? currentValue?.discountData?.familyCardSection?.cardSelectedType?.value : [];
      return nameDiscount
    }, 0);

  }

  const calculateSinglePrice = (array: any, passengerType: EPassengerFormVariant) => {
    const initialValue = 0;
    const sumWithInitial = array?.reduce((previousValue: any, currentValue: any) => {

      const ticketPrice = passengerType === EPassengerFormVariant.CHILD ? currentValue?.childTarif?.price : currentValue?.adultTarif?.price 
      return previousValue + ticketPrice || 0
    }, initialValue);

    return sumWithInitial;
  }



  const addDiscountInSummary = () => {
 
    const discountCardSum = getDiscountCardSum();
    const familyCardDiscountSum = getFamilyCardDiscountSum();
    const familyCardDiscountName=getFamilyCardDiscountName();
    const totalDiscount = discountCardSum + familyCardDiscountSum;
    const discountsCardsList = getDiscountCardValues();

    const descuento=departureDiscountCard?.map((item:any) =>item?.cardsSection?.discountCardsList).flat(1);
    const literalDiscount=descuento?.find((item: any) => item.id == discountsCardsList?.discountCard?.type?.id);
    const resultMappingDiscount=mappingDiscountObject(literalDiscount,familyCardDiscountName,priceItemsList,discountCardSum,familyCardDiscountSum)
    
    /*const discountObject = {
      text:  t("literals.discounts"),
      price: -totalDiscount,
      priceText: `${formatPrice(-totalDiscount)} €`,
      id: "discount"
    }*/
    const copyPriceItemsList = resultMappingDiscount;

    if (totalDiscount !== 0) {
      //copyPriceItemsList.splice(1, 1, discountObject);
      //setPriceItemsList([...copyPriceItemsList]);
      setPriceItemsList([...resultMappingDiscount]);
    } else {
      copyPriceItemsList.splice(1, 1)
      setPriceItemsList([...copyPriceItemsList]);
    }

  }
  const mappingDiscountObject = (discountCard:any,discountFamily:any,priceItemsList:any,discountCardSum:any,familyCardDiscountSum:any) => {
    const result=[]
    if(priceItemsList.length!=0){
      result.push(priceItemsList[0])
    }
    if(discountCard!=undefined){
      const aux = {
        text:  discountCard?.id,
        price: -discountCardSum,
        priceText: `${formatPrice(-discountCardSum)} €`,
        id: "discount"
      }
      result.push(aux)
    }

    if(discountFamily.length!=0){
      const aux = {
        text:  discountFamily?.id==="GENERAL" ? t("literals.generalTextDiscount"):t("literals.specialTextDiscount"),
        price: -familyCardDiscountSum,
        priceText: `${formatPrice(-familyCardDiscountSum)} €`,
        id: "discount",
        percentageDiscount:discountFamily?.percentageDiscount,
        info:discountFamily?.id==="GENERAL" ?"GENERAL" : "SPECIAL" 
      }
      result.push(aux)
    }
    return result
  }

  const savePassengerInfoAndGoNextStep = (passengerList: []) => {
    const allClosedList = passengerList?.map((item: IPassengerList) => {
      return {
        ...item,
        isOpen: false
      }
    });
    addDiscountInSummary();
    savePassengerBody();
    setPassengerList(allClosedList);
 
    const pasajeros = _mapPassengers(allClosedList); // para pantalla extras
    setPassengersExtrasCard(pasajeros);
    nextStep();
  };

  const addSeatingAmountInSummary = (seantingSelectedArray: any) => {
    const totalPrice = seantingSelectedArray?.totalPrice;
    const seantingObject = {
      text: t("literals.seatSelection"),
      price: totalPrice,
      priceText: totalPrice === 0 ? t("literals.free") : `${formatPrice(totalPrice)} €`,
      id: "seating",
      info:seantingSelectedArray?.departureSectionData[0]?.id
    }

    let copyPriceItemsList = priceItemsList;
    const index = copyPriceItemsList.findIndex((item: any) => {
      return item?.id === 'seating';
    });

    if (index > 0) {
      copyPriceItemsList.splice(index, 1, seantingObject);
    } else {
      copyPriceItemsList.push(seantingObject);
    }
    setPriceItemsList([...copyPriceItemsList]);
  }

  const saveSeatingInfoAndGoNextStep = (event: CustomEvent) => {
    const seantingSelectedArray = event?.detail;
    addSeatingAmountInSummary(seantingSelectedArray);
    setSeatingSelected(seantingSelectedArray);
    nextStep();
  };

  const saveExtraInfoAndGoNextStep = (event: CustomEvent) => {
    // TODO
    const extraSelectedArray = event?.detail;
    // hay que actualizar el body de creacion
    addExtraAmountInSummary(extraSelectedArray);
    setExtraSelected(extraSelectedArray);
    nextStep();
  };

  const addExtraAmountInSummary = (extrasSelectedArray: any) => {
    let totalPrice = 0;

    /* Departure */
    (extrasSelectedArray?.departureSectionData?.extrasSelected || []).forEach((extra: any) => {
      totalPrice += extra.totalPrice;
    });
    /* Arrival */
    (extrasSelectedArray?.returnSectionData?.extrasSelected || []).forEach((extra: any) => {
      totalPrice += extra.totalPrice;
    });
    const extrasObject = {
      text: t("literals.extrasIncluded"),
      price: totalPrice,
      priceText: totalPrice === 0 ? t("literals.free") : `${formatPrice(totalPrice)} €`,
      id: "extras"
    }

    let copyPriceItemsList = priceItemsList;
    const index = copyPriceItemsList.findIndex((item: any) => {
      return item?.id === 'extras';
    });

    if (index > 0) {
      copyPriceItemsList.splice(index, 1, extrasObject);
    } else {
      copyPriceItemsList.push(extrasObject);
    }
    setPriceItemsList([...copyPriceItemsList]);
  }

  const getBirthday = (item: IPassengerList) => {
    return `${item?.userData?.year}-${item?.userData?.month}-${item?.userData?.day}`;
  };

  const getPhoneBody = (item: IPassengerList) => {
    return item?.accordionId === EPassengerFormVariant.BABY
      ? {}
      : {
        phone: {
          prefix: item?.userData?.prefixNumber,
          number: item?.userData?.phoneNumber
        }
      }
  }

  const getDocumentBody = (item: IPassengerList) => {
    return item?.accordionId === EPassengerFormVariant.BABY
      ? {}
      : {
        identificationDocument: {
          type: item?.userData?.identificationDocument?.type,
          value: item?.userData?.identificationDocument?.value
        }
      }
  }

  const passengerMapBody = (): Traveller[] => {
    const travellesList: Traveller[] = passengerList?.map(
      (item: IPassengerList): Traveller => {
        const isBaby = item?.accordionId === EPassengerFormVariant.BABY;
        const associatedAdult: string =
          isBaby && item.userData?.associatedAdult
            ? item.userData?.associatedAdult
            : "";
        return {
          type: item?.accordionId,
          personalInformation: {
            customerFullName: {
              name: item?.userData?.name,
              secondSurname: item?.userData?.surname2,
              firstSurname: item?.userData?.surname,
            },
            ...(isBaby ? {} : { email: item?.userData?.email }),
            ...(isBaby
              ? { associatedAdult: Number(associatedAdult.slice(-1)) }
              : {}),
            ...getPhoneBody(item),
            ...getDocumentBody(item),
            ...(item?.accordionId === EPassengerFormVariant.ADULT
              ? {}
              : { birthday: getBirthday(item) }),
          },
        };
      }
    );
    return travellesList;
  };

  const savePassengerBody = () => {
    const tripSummaryDetails: ITripSelectedDetails = {
      ...tripSelectedDetails,
      body: {
        ...tripSelectedDetails.body,
        travellers: passengerMapBody(),
      },
    };
    setTripSelectedDetails(tripSummaryDetails);
    setTripSummaryDetail(tripSummaryDetails);
  };

  const goBackStepper = (step: number) => {
    setCurrentStep(step);
  };

  const nextStep = () => {
    currentStep === 2 && resumeStepMapSection();
    setCurrentStep(currentStep + 1);
  }


  const getComponent = (currentStep: number): JSX.Element => {
    let currentComponent: JSX.Element = <div></div>;
    switch (currentStep) {
      case 0:
        currentComponent = (
          <PPassengerStep
            literals={passengerStepLiteralsPageData}
            passengerList={passengerList}
            onSendPassengerListEmit={(ev) =>
              savePassengerInfoAndGoNextStep(ev?.detail)
            }
            returnDiscountCards={returnDiscountCard || {}}
            departureDiscountCards={departureDiscountCard}
            onGoBackEmit={() => {
              const params = new URLSearchParams(window?.location?.search);
              const path = sessionStorage.getItem("raas-url")|| '/trip';
              setReturnTripSelectedDetails(null as any);
              removeItemStorage(SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL);
              navigate(path);
            }}
          ></PPassengerStep>
        );
        break;
      case 1:
        currentComponent = (
          <PSeatingStep
            literals={seatingPageliterals}
            departureSeatingList={departureSeating || {}}
            returnSeatingList={returnSeating || {}}
            seatingSelected={seatingSelected}
            onSeatingSelectedPageEventEmitter={(ev: any) => saveSeatingInfoAndGoNextStep(ev)}
          >
          </PSeatingStep>
        );
        break;
      case 2:
        currentComponent = (
          <PExtrasTrip
            onExtraSelectedPageEvent={(e) => saveExtraInfoAndGoNextStep(e)}
            extrasSelected={extraSelected}
            literals={ExtrasPageLiterals(t)}
            departureList={departureExtrasCard}
            returnList={returnExtrasCard}
            passengers={passengersExtrasCard}
            onNextPage={() => nextStep()}
          />
        );
        break;
      case 3:
        currentComponent = (
          <PResumeStep
            literals={resumeLiteralsPageLocal}
            departureResumeList={resumeDepartureSection}
            returnResumeList={resumeReturnSection}
            onContinueToResumeEvent={() => setAveBodyAndNavigateToResumeTrip()}
          ></PResumeStep>
        )
        break;
    }
    return currentComponent;
  };
  return (
    <>
      <div className="ave-flow">
        <div className="ave-stepper-container">
          <div className="ave-flow_stepper">
            <UiAveStepper
              steps={steps(t)}
              activeStep={currentStep}
              onEventStepChanged={(ev) => goBackStepper(ev?.detail)}
            ></UiAveStepper>
          </div>
        </div>
        <div className="ave-flow_body">
          <div className="section-body">

            <div className="left-section">{getComponent(currentStep)}</div>
            <div className="rigth-section">
          
              <MSummaryAveStepper
                literals={SummaryAveLiterals(t)}
                topSectionInfo={summaryTopSection}
                itemsPrice={priceItemsList}
                otherTransportPrice={otherTransportSumPrice}
                isTripWithReturn={tripReturnSelectedDetails?.aveReturn?.isAveSelected}
                isPreTrip={showAproxLiteralSection}
                >
              </MSummaryAveStepper>
            </div>
          </div>
          <div className="section">
            <div className="mt-80">
              <LegalFooter literals={footerLiterals}></LegalFooter>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
